/**
 * FOSSA Global Typographic Variables
 */
export const fossaPrimaryFont = `'Open Sauce Two', 'Open Sauce', 'Helvetica Neue', Helvetica, Arial, sans-serif`;
export const fossaSecondaryFont = `'Open Sauce Two Medium', 'Open Sauce', 'Helvetica Neue', Helvetica, Arial, sans-serif`;
export const fossaMonospaceFont = `'iA Writer Quattro', 'SF Mono', 'Menlo', 'Liberation Mono', 'DejaVu Sans Mono', 'Consolas', monospace`;
